import { useFormik } from "formik";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import CompleteSignUp from "./complete-sign-up";
import Document from "./components/document/Document";
import ConfirmSignUp from "./confirm-sign-up";
import SignUp from "./sign-up";
import { validationSchema } from "./sign-up/schema";
import "./styles.scss";

const Clinic = () => {
  const [screen, setScreen] = useState(0);
  const { t } = useTranslation();
  console.log(screen, "aaa");

  const initialValues = useMemo(() => {
    return {
      address: {},
    };
  }, []);

  const onSubmit = (values) => {
    setScreen(1);
  };

  const formFormik = useFormik({
    validateOnChange: false,
    initialValues,
    validationSchema: validationSchema(t),
    onSubmit,
    enableReinitialize: true,
  });

  if (screen === 2) {
    return <CompleteSignUp setScreen={setScreen} values={formFormik.values} />;
  }
  if (screen === 1) {
    return <ConfirmSignUp setScreen={setScreen} values={formFormik.values} />;
  }
  return (
    <>
      <SignUp setScreen={setScreen} formFormik={formFormik} />
    </>
  );
};
export default Clinic;
